export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7692.7cb2012f.jpg";